import { useEffect, useState } from 'react';
import { useValidateProfilePictureMutation } from '../../../../../app/Slices/SevenDayApiSlice';
import toast from '../../../../shared/Toast';

export const usePhotoValidation = (photo?: File) => {
    const [rejectionReasons, setRejectionReasons] = useState<string[]>([]);
    const [validationToken, setValidationToken] = useState<string | null>(null);
    const [validateProfilePicture, { isLoading: isValidating }] =
        useValidateProfilePictureMutation();

    const validatePhoto = async (photo: File) => {
        try {
            const form = new FormData();
            form.append('file', photo);

            const response = await validateProfilePicture(form).unwrap();
            setRejectionReasons(response.rejectionReasons ?? []);
            setValidationToken(response.validationToken ?? null);
        } catch (_error) {
            toast.error('Error validating profile picture');
        }
    };

    useEffect(() => {
        if (!photo) return;
        validatePhoto(photo);

        return () => {
            setRejectionReasons([]);
            setValidationToken(null);
        };
    }, [photo]);

    return { rejectionReasons, isValidating, validationToken };
};
